import { Loading } from 'element-ui';
import config from '../config';

// loading展示超时时间
const TIMEOUT = config.loadingTimeout;

// 业务侧消息队列
let businessShowQueue = [];
// let businessHideQueue = [];

// 拦截器的消息队列
let commonShowQueue = [];
let commonHideQueue = [];

/**
 * loading统一处理工厂
 * @type {{timer: null, hide(): void, clearTimeout(): void, show(*=): void, checkCanHide(): boolean}}
 */
const factory = {
  instance: null,
  /**
   * 计时器
   */
  timer: null,
  /**
   * 统一展示入口
   * @param val
   */
  show (val) {
    // 如果业务提示队列有数据，则优先显示队列最后一项数据
    if (businessShowQueue.length > 0) {
      val = businessShowQueue[businessShowQueue.length - 1];
    }
    this.instance = Loading.service({
      // target: '.global-layout',
      // fullscreen: true,
      text: val,
      background: 'rgba(0,0,0,.8)',
    });
    if (this.timer) {
      this.clearTimeout();
    }
    this.timer = setTimeout(() => {
      // 设置超时隐藏
      this.hide();
    }, TIMEOUT);
  },
  /**
   * 关闭入口
   */
  hide () {
    if (this.checkCanHide()) {
      this.clearTimeout();
      this.resetData();
      this.instance.close();
    }
  },
  /**
   * 清除时间id
   */
  clearTimeout () {
    clearInterval(this.timer);
    this.timer = null;
  },
  /**
   * 验证是否可以关闭loading
   * @returns {boolean}
   */
  checkCanHide () {
    // 如果拦截器的show以及hide的调用次数一致的话，认为接口请求已经完成，即可关闭
    return commonShowQueue.length === commonHideQueue.length;
  },

  /**
   * 清空已用的队列
   */
  resetData () {
    businessShowQueue = [];
    // businessHideQueue = [];
    commonShowQueue = [];
    commonHideQueue = [];
  },
};

/**
 * 包装原有的$loading for request interceptors
 * @type {{hide(): void, show(*=): void}}
 */
const commonLoading = {
  show (val) {
    // 把拦截器传过来的信息推到时序队列
    commonShowQueue.push(val);
    factory.show(val);
  },
  hide () {
    if (commonShowQueue.length) {
      commonHideQueue.push(+new Date());
    }
    factory.hide();
  },
};

/**
 * 包装原有的$loading
 * @type {{hide(): void, show(*=): void}}
 */
const loading = {
  show (val) {
    // 把业务侧传过来的信息推到时序队列
    businessShowQueue.push(val);
    factory.show(val);
  },
  hide () {
    // businessHideQueue.push(+new Date());
    factory.hide();
  },
};

export {
  factory,
  loading,
  commonLoading,
};
